import { Component, Vue } from "vue-property-decorator";
import OrderService from "@/services/order_service";
import { OrderStatus } from "@/models/order/helpers";
import { AuthError, GenericError } from "@/services/error_service";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { LineItem } from "@/models/order/order";
import { ProductType } from "@/models/products/product";

@Component
export class OrderMixin extends Vue {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrderItems))
  items!: LineItem[];

  protected productType = ProductType;
  protected action: null | "edit" | "dupe" = null;
  protected showModal = false;
  protected id = "";
  protected status: OrderStatus | null = null;
  protected orderStatus = OrderStatus;
  protected orderService = new OrderService();

  protected confirm(): void {
    if (this.action === "edit") {
      this.editOpenQuote();
    } else {
      this.duplicateOrder();
    }
  }

  protected duplicateOrder(): void {
    this.$router.push("/cart/" + this.id + "?status=" + this.status);
  }

  protected editOpenQuote(): void {
    this.$router.push("/cart/" + this.id + "?edit=true&status=" + this.status);
  }

  protected async download(id: string): Promise<void> {
    try {
      const blobData = await this.orderService.downloadOrderInvoice(id);
      this.forceDownload(blobData, `Frankford Umbrellas Submitted Quote #${id.slice(-7)}`);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup(err.message);
    }
  }

  protected async downloadQuote(id: string): Promise<void> {
    try {
      const blobData = await this.orderService.downloadQuoteInvoice(id);
      this.forceDownload(blobData, `Frankford Umbrellas Open Quote #${id.slice(-7)}`);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup(err.message);
    }
  }

  protected forceDownload(blobData: any, fileName: string): void {
    const url = window.URL.createObjectURL(blobData);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.pdf`);
    document.body.appendChild(link);
    link.click();
  }

  protected close(): void {
    this.id = "";
    this.action = null;
    this.status = null;
    this.showModal = false;
  }

  protected toggleConfirmationModal(
    id: string,
    action: "edit" | "dupe",
    status: OrderStatus
  ): void {
    this.action = action;
    this.status = status;
    this.id = id;
    this.showModal = true;
  }

  protected editItem(idx?: number): void {
    const index = idx !== undefined ? idx : this.items.length - 1;
    const item = this.items[index];
    const indexAsString = index > 0 ? index.toString() : "0";
    const handle =
      item.product_type === this.productType.Base
        ? item.model
        : item.product_line;
    this.$router.push({
      name: "ItemCustomization",
      query: { handle: handle, cart: indexAsString },
      params: {
        product: item.product_type,
        edit: "true"
      }
    });
  }
}
